module.exports = __webpack_public_path__ + "img/title2.2fa33551.png";